import * as React from "react";
import * as ReactQuery from "react-query";

import { LocalizationProvider, PresenterForScrollProvider } from "../Common";
import { IS_HORIZONTAL_FILTER_ENABLED } from "./flags";

import {
  ReactPlpInitialStateProvider,
  PlpPresenterForTheFilterMenuProvider,
  PlpPresenterForTheSortingMenuProvider,
  PlpPresenterForTheProductsMasonryProvider,
  PlpPresenterForRoutingTheResultsPageProvider,
  PlpAnalyticsProvider,
  PlpUrlStateProvider,
  PlpDataSourceUrlStateProvider,
  PlpDataTargetUrlStateProvider,
  PlpDataSourceProductListProvider,
  ProductListProvider,
} from "./providers";

import { PageContents } from "./PageContents";

interface AppProps {
  mountElement: Element | null;
}

const queryClient = new ReactQuery.QueryClient();

export const App: React.FunctionComponent<AppProps> = (props) => {
  const { mountElement } = props;

  React.useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }
    const className = "plp-hfe";
    if (!IS_HORIZONTAL_FILTER_ENABLED) {
      document.body.classList.remove(className);
      return;
    }
    document.body.classList.add(className);
    return () => {
      document.body.classList.remove(className);
    };
  }, []);

  return (
    <React.Fragment>
      <ReactQuery.QueryClientProvider client={queryClient}>
        <PresenterForScrollProvider>
          <ReactPlpInitialStateProvider mountElement={mountElement}>
            <LocalizationProvider>
              <PlpAnalyticsProvider>
                <PlpDataSourceProductListProvider>
                  <PlpDataSourceUrlStateProvider>
                    <PlpDataTargetUrlStateProvider>
                      <PlpUrlStateProvider>
                        <ProductListProvider>
                          <PlpPresenterForTheFilterMenuProvider>
                            <PlpPresenterForTheSortingMenuProvider>
                              <PlpPresenterForTheProductsMasonryProvider>
                                <PlpPresenterForRoutingTheResultsPageProvider>
                                  <PageContents />
                                </PlpPresenterForRoutingTheResultsPageProvider>
                              </PlpPresenterForTheProductsMasonryProvider>
                            </PlpPresenterForTheSortingMenuProvider>
                          </PlpPresenterForTheFilterMenuProvider>
                        </ProductListProvider>
                      </PlpUrlStateProvider>
                    </PlpDataTargetUrlStateProvider>
                  </PlpDataSourceUrlStateProvider>
                </PlpDataSourceProductListProvider>
              </PlpAnalyticsProvider>
            </LocalizationProvider>
          </ReactPlpInitialStateProvider>
        </PresenterForScrollProvider>
      </ReactQuery.QueryClientProvider>
    </React.Fragment>
  );
};
